module.exports = __webpack_public_path__ + "img/icon.c46a87a4.png";